export const BASE_NOMINATIM_URL: string = 'nominatim.openstreetmap.org';
export const DEFAULT_VIEW_BOX: string = 'viewbox=-25.0000%2C70.0000%2C50.0000%2C40.0000';
export const SESSION_FILTER_KEY: string = 'keye.filter';
export const TOKEN_KEY: string   = 'keye.auth-token';
export const TOKEN_IMG_KEY: string   = 'keye.img-token';
export const USER_KEY: string   = 'keye.currentUser';
